import { render, staticRenderFns } from "./price-defaults.vue?vue&type=template&id=240df162&scoped=true&"
import script from "./price-defaults.vue?vue&type=script&lang=js&"
export * from "./price-defaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240df162",
  null
  
)

export default component.exports